/**
 * Extended CMS Static Asset mappings for:
 * 1. Who We Empower (Main + 7 subpages)
 * 2. Programs (8 subpages)
 * 3. Partnership (Partnership1.tsx)
 */

// -------------------------------------------------------------
// 1. Who We Empower (Main Page)
// -------------------------------------------------------------
import empowerMainHero from "../assets/Who we empower/Img1.png";
import empowerCard1 from "../assets/Who we empower/Img2.png";
import empowerCard2 from "../assets/Who we empower/Img3.png";
import empowerCard3 from "../assets/Who we empower/Img4.png";
import empowerCard4 from "../assets/Who we empower/Img5.png";
import empowerCard5 from "../assets/Who we empower/Img6.png";
import empowerCard6 from "../assets/Who we empower/Img7.png";
import empowerCard7 from "../assets/Who we empower/Img8.png";

import empowerCsrImg1 from "../assets/Who we empower/CSR/Img1.jpeg";
import empowerCsrImg2 from "../assets/Who we empower/CSR/Img2.jpeg";
import empowerCsrImg3 from "../assets/Who we empower/CSR/Img3.jpeg";
import empowerCsrIcon1 from "../assets/Who we empower/CSR/Icon1.svg";
import empowerCsrIcon2 from "../assets/Who we empower/CSR/Icon2.svg";
import empowerCsrIcon3 from "../assets/Who we empower/CSR/Icon3.svg";
import empowerCsrIcon4 from "../assets/Who we empower/CSR/Icon4.svg";
import empowerCsrIcon5 from "../assets/Who we empower/CSR/Icon5.svg";
import empowerCsrIcon6 from "../assets/Who we empower/CSR/Icon6.svg";
import empowerCsrIcon7 from "../assets/Who we empower/CSR/Icon7.svg";

import empowerBenefitIcon1 from "../assets/Who we empower/partnership/Icon1.svg";
import empowerBenefitIcon2 from "../assets/Who we empower/partnership/Icon2.svg";
import empowerBenefitIcon3 from "../assets/Who we empower/partnership/Icon3.svg";
import empowerBenefitIcon4 from "../assets/Who we empower/partnership/Icon4.svg";
import empowerBenefitIcon5 from "../assets/Who we empower/partnership/Icon5.svg";

// -------------------------------------------------------------
// 2. Who We Empower Subpages
// -------------------------------------------------------------
// Student
import studentBg from "../assets/Who we empower/Student/BG.svg";
import studentHero from "../assets/Who we empower/Student/Img1.png";
import studentFutureTop from "../assets/Who we empower/Student/Img2.png";
import studentFutureBottom from "../assets/Who we empower/Student/Img3.png";
import studentPeople from "../assets/Who we empower/Student/Img4.png";
import studentCommunity from "../assets/Who we empower/Student/Img5.png";
import studentIcon1 from "../assets/Who we empower/Student/Icon1.svg";
import studentIcon2 from "../assets/Who we empower/Student/Icon2.svg";
import studentIcon3 from "../assets/Who we empower/Student/Icon3.svg";
import studentIcon4 from "../assets/Who we empower/Student/Icon4.svg";
import studentIcon5 from "../assets/Who we empower/Student/Icon5.svg";
import studentIcon6 from "../assets/Who we empower/Student/Icon6.svg";
import studentIcon7 from "../assets/Who we empower/Student/Icon7.svg";
import studentIcon8 from "../assets/Who we empower/Student/Icon8.svg";
import studentIcon9 from "../assets/Who we empower/Student/Icon9.svg";

// Graduates & Job Seekers
import gradBg from "../assets/Who we empower/Graduates&Job/BG.svg";
import gradHero from "../assets/Who we empower/Graduates&Job/Img1.png";
import gradFutureTop from "../assets/Who we empower/Graduates&Job/Img2.png";
import gradFutureBottom from "../assets/Who we empower/Graduates&Job/Img3.png";
import gradPeople from "../assets/Who we empower/Graduates&Job/Img4.png";
import gradCommunity from "../assets/Who we empower/Graduates&Job/Img5.png";
import gradIcon1 from "../assets/Who we empower/Graduates&Job/Icon1.svg";
import gradIcon2 from "../assets/Who we empower/Graduates&Job/Icon2.svg";
import gradIcon3 from "../assets/Who we empower/Graduates&Job/Icon3.svg";
import gradIcon4 from "../assets/Who we empower/Graduates&Job/Icon4.svg";
import gradIcon5 from "../assets/Who we empower/Graduates&Job/Icon5.svg";
import gradIcon6 from "../assets/Who we empower/Graduates&Job/Icon6.svg";
import gradIcon7 from "../assets/Who we empower/Graduates&Job/Icon7.svg";
import gradIcon8 from "../assets/Who we empower/Graduates&Job/Icon8.svg";
import gradIcon9 from "../assets/Who we empower/Graduates&Job/Icon9.svg";

// Engineers & Professionals
import engBg from "../assets/Who we empower/Engineers&Professionals/BG.svg";
import engHero from "../assets/Who we empower/Engineers&Professionals/Img1.png";
import engFutureTop from "../assets/Who we empower/Engineers&Professionals/Img2.png";
import engFutureBottom from "../assets/Who we empower/Engineers&Professionals/Img3.png";
import engPeople from "../assets/Who we empower/Engineers&Professionals/Img4.png";
import engCommunity from "../assets/Who we empower/Engineers&Professionals/Img5.png";
import engIcon1 from "../assets/Who we empower/Engineers&Professionals/Icon1.svg";
import engIcon2 from "../assets/Who we empower/Engineers&Professionals/Icon2.svg";
import engIcon3 from "../assets/Who we empower/Engineers&Professionals/Icon3.svg";
import engIcon4 from "../assets/Who we empower/Engineers&Professionals/Icon4.svg";
import engIcon5 from "../assets/Who we empower/Engineers&Professionals/Icon5.svg";
import engIcon6 from "../assets/Who we empower/Engineers&Professionals/Icon6.svg";
import engIcon7 from "../assets/Who we empower/Engineers&Professionals/Icon7.svg";
import engIcon8 from "../assets/Who we empower/Engineers&Professionals/Icon8.svg";
import engIcon9 from "../assets/Who we empower/Engineers&Professionals/Icon9.svg";

// Independent Engineers
import indBg from "../assets/Who we empower/IndependentEngineers/BG.svg";
import indHero from "../assets/Who we empower/IndependentEngineers/Img1.png";
import indFutureTop from "../assets/Who we empower/IndependentEngineers/Img2.png";
import indFutureBottom from "../assets/Who we empower/IndependentEngineers/Img3.png";
import indPeople from "../assets/Who we empower/IndependentEngineers/Img4.png";
import indCommunity from "../assets/Who we empower/IndependentEngineers/Img5.png";
import indIcon1 from "../assets/Who we empower/IndependentEngineers/Icon1.svg";
import indIcon2 from "../assets/Who we empower/IndependentEngineers/Icon2.svg";
import indIcon3 from "../assets/Who we empower/IndependentEngineers/Icon3.svg";
import indIcon4 from "../assets/Who we empower/IndependentEngineers/Icon4.svg";
import indIcon5 from "../assets/Who we empower/IndependentEngineers/Icon5.svg";
import indIcon6 from "../assets/Who we empower/IndependentEngineers/Icon6.svg";
import indIcon7 from "../assets/Who we empower/IndependentEngineers/Icon7.svg";
import indIcon8 from "../assets/Who we empower/IndependentEngineers/Icon8.svg";
import indIcon9 from "../assets/Who we empower/IndependentEngineers/Icon9.svg";

// Educational Institutions
import instBg from "../assets/Who we empower/Educational_Institutions/BG.svg";
import instHero from "../assets/Who we empower/Educational_Institutions/Img1.png";
import instFutureTop from "../assets/Who we empower/Educational_Institutions/Img2.svg";
import instFutureBottom from "../assets/Who we empower/Educational_Institutions/Img3.svg";
import instPeople from "../assets/Who we empower/Educational_Institutions/Img4.svg";
import instCommunity from "../assets/Who we empower/Educational_Institutions/Img5.png";
import instIcon1 from "../assets/Who we empower/Educational_Institutions/Icon1.svg";
import instIcon2 from "../assets/Who we empower/Educational_Institutions/Icon2.svg";
import instIcon3 from "../assets/Who we empower/Educational_Institutions/Icon3.svg";
import instIcon4 from "../assets/Who we empower/Educational_Institutions/Icon4.svg";
import instIcon5 from "../assets/Who we empower/Educational_Institutions/Icon5.svg";
import instIcon6 from "../assets/Who we empower/Educational_Institutions/Icon6.svg";
import instIcon7 from "../assets/Who we empower/Educational_Institutions/Icon7.svg";
import instIcon8 from "../assets/Who we empower/Educational_Institutions/Icon8.svg";
import instIcon9 from "../assets/Who we empower/Educational_Institutions/Icon9.svg";

// Industry & Employers
import empBg from "../assets/Who we empower/Industry&Employers/BG.svg";
import empHero from "../assets/Who we empower/Industry&Employers/Img1.png";
import empFutureTop from "../assets/Who we empower/Industry&Employers/Img2.png";
import empFutureBottom from "../assets/Who we empower/Industry&Employers/Img3.png";
import empPeople from "../assets/Who we empower/Industry&Employers/Img4.png";
import empCommunity from "../assets/Who we empower/Industry&Employers/Img5.png";
import empIcon1 from "../assets/Who we empower/Industry&Employers/Icon1.svg";
import empIcon2 from "../assets/Who we empower/Industry&Employers/Icon2.svg";
import empIcon3 from "../assets/Who we empower/Industry&Employers/Icon3.svg";
import empIcon4 from "../assets/Who we empower/Industry&Employers/Icon4.svg";
import empIcon5 from "../assets/Who we empower/Industry&Employers/Icon5.svg";
import empIcon6 from "../assets/Who we empower/Industry&Employers/Icon6.svg";
import empIcon7 from "../assets/Who we empower/Industry&Employers/Icon7.svg";
import empIcon8 from "../assets/Who we empower/Industry&Employers/Icon8.svg";
import empIcon9 from "../assets/Who we empower/Industry&Employers/Icon9.svg";

// Mentors & Experts
import mentorBg from "../assets/Who we empower/Mentors&Experts/BG.svg";
import mentorHero from "../assets/Who we empower/Mentors&Experts/Img1.png";
import mentorFutureTop from "../assets/Who we empower/Mentors&Experts/Img2.png";
import mentorFutureBottom from "../assets/Who we empower/Mentors&Experts/Img3.png";
import mentorPeople from "../assets/Who we empower/Mentors&Experts/Img4.png";
import mentorCommunity from "../assets/Who we empower/Mentors&Experts/Img5.png";
import mentorIcon1 from "../assets/Who we empower/Mentors&Experts/Icon1.svg";
import mentorIcon2 from "../assets/Who we empower/Mentors&Experts/Icon2.svg";
import mentorIcon3 from "../assets/Who we empower/Mentors&Experts/Icon3.svg";
import mentorIcon4 from "../assets/Who we empower/Mentors&Experts/Icon4.svg";
import mentorIcon5 from "../assets/Who we empower/Mentors&Experts/Icon5.svg";
import mentorIcon6 from "../assets/Who we empower/Mentors&Experts/Icon6.svg";
import mentorIcon7 from "../assets/Who we empower/Mentors&Experts/Icon7.svg";
import mentorIcon8 from "../assets/Who we empower/Mentors&Experts/Icon8.svg";
import mentorIcon9 from "../assets/Who we empower/Mentors&Experts/Icon9.svg";
import mentorIcon10 from "../assets/Who we empower/Mentors&Experts/Icon10.svg";
import mentorIcon11 from "../assets/Who we empower/Mentors&Experts/Icon11.svg";

// -------------------------------------------------------------
// 3. Program Subpages Assets
// -------------------------------------------------------------
import prgSkillHero from "../assets/program/Rectangle 4841.svg";
import prgCareerHero from "../assets/program/Rectangle 4841 (1).svg";
import prgIndHero from "../assets/program/Rectangle 4841 (2).svg";
import prgWelfareHero from "../assets/program/Rectangle 4841 (3).svg";
import prgAcademiaHero from "../assets/program/program5/Rectangle 4800 (1).svg";
import prgTechHero from "../assets/program/program6/Rectangle 4800 (1).svg";
import prgCommHero from "../assets/program/program7/pexels-shootsaga-31851560 6.svg";
import prgIndiaHero from "../assets/program/program8/pexels-shootsaga-31851560 6.svg";

import prgSkillFocusBanner from "../assets/program/Rectangle 4846.svg";
import prgCareerFocusBanner from "../assets/program/Rectangle 4845.svg";
import prgIndFocusBanner from "../assets/program/Rectangle 4845 (3).svg";
import prgWelfareFocusBanner from "../assets/program/Rectangle 4845 (1).svg";
import prgAcademiaFocusBanner from "../assets/program/program5/Rectangle 4845.svg";
import prgTechFocusBanner from "../assets/program/program6/Rectangle 4845.svg";
import prgCommFocusBanner from "../assets/program/program7/Rectangle 4845.svg";
import prgIndiaFocusBanner from "../assets/program/program8/Rectangle 4845.svg";

import prgJoinPhoto1 from "../assets/program/Frame 1000010666.svg";
import prgJoinPhoto2 from "../assets/program/Frame 1000010666 copy.svg";
import prgJoinPhoto3 from "../assets/program/Frame 1000010666 copy 2.svg";
import prgJoinPhoto4 from "../assets/program/Frame 1000010666 (1).svg";
import prgJoinPhoto5 from "../assets/program/program5/Frame 1000010666.svg";
import prgJoinPhoto6 from "../assets/program/program6/Frame 1000010666.svg";
import prgJoinPhoto7 from "../assets/program/program7/Frame 1000010666.svg";
import prgJoinPhoto8 from "../assets/program/program8/Frame 1000010666.svg";

import prgBenefitsPhoto1 from "../assets/program/Frame 1000010667.png";
import prgBenefitsPhoto5 from "../assets/program/program5/Frame 1000010667.svg";
import prgBenefitsPhoto6 from "../assets/program/program6/Frame 1000010667.svg";
import prgBenefitsPhoto7 from "../assets/program/program7/Frame 1000010667.svg";
import prgBenefitsPhoto8 from "../assets/program/program8/Frame 1000010667.svg";

import prgCtaBannerEngineers from "../assets/program/banner_engineers.png";

// Program icons
import prgIconHandshake from "../assets/program/mdi_handshake.svg";
import prgIconTech from "../assets/program/Frame 1000010256.svg";
import prgIconAccountTick from "../assets/program/mdi_account-tick.svg";
import prgIconEng from "../assets/program/ic_baseline-engineering.svg";
import prgIconBriefcase from "../assets/program/fluent_briefcase-search-20-regular.png";
import prgIconSearchInsights from "../assets/program/material-symbols_search-insights-rounded.svg";
import prgIconFactory from "../assets/program/clarity_factory-line.svg";
import prgIconJobSearch from "../assets/program/hugeicons_job-search.svg";
import prgIconGroup1 from "../assets/program/Group (1).svg";
import prgIconBrainSparkle from "../assets/program/fluent_brain-sparkle-48-regular.svg";
import prgIconIam from "../assets/program/gcp_identity-and-access-management.svg";
import prgIconIdCard from "../assets/program/hugeicons_identity-card (1).svg";
import prgIconCommunityBox from "../assets/program/boxicons_community-filled.svg";

// Program subpages gear icons
import prgIconGearStudents from "../assets/program/bi_gear-fill copy.svg";
import prgIconGearGraduates from "../assets/program/bi_gear-fill (2) copy.svg";
import prgIconGearJobSeekers from "../assets/program/bi_gear-fill (3).svg";
import prgIconGearEarlyCareer from "../assets/program/bi_gear-fill (1) copy.svg";
import prgIconGearWorking from "../assets/program/bi_gear-fill copy 2.svg";
import prgIconGearFreelance from "../assets/program/bi_gear-fill (3) copy.svg";
import prgIconGearConsultants from "../assets/program/bi_gear-fill (1) copy 2.svg";
import prgIconGearEntrepreneurs from "../assets/program/bi_gear-fill (2) copy 2.svg";

// Program 5 icons
import prg5IconConnect from "../assets/program/program5/streamline-freehand-color_collaboration-meeting-team-file.svg";
import prg5IconPractical from "../assets/program/program5/Frame 1000010256.svg";
import prg5IconPartnerships from "../assets/program/program5/Vector (22).svg";
import prg5IconGraduates from "../assets/program/program5/mdi_handshake.svg";
import prg5IconGearInstitutions from "../assets/program/program5/bi_gear-fill.svg";
import prg5IconGearStudentsFaculty from "../assets/program/program5/bi_gear-fill (1).svg";
import prg5IconGearProfessionals from "../assets/program/program5/bi_gear-fill (2).svg";
import prg5IconGearCompanies from "../assets/program/program5/bi_gear-fill (3).svg";

// Program 6 icons
import prg6IconInnovation from "../assets/program/program6/hugeicons_ai-innovation-01 (1).svg";
import prg6IconFutureTech from "../assets/program/program6/Group (2).svg";
import prg6IconAdoption from "../assets/program/program6/streamline-plump_ai-technology-spark-remix.svg";
import prg6IconFutureReady from "../assets/program/program6/bi_gear-fill (1).svg";
import prg6IconGearWorking from "../assets/program/program6/bi_gear-fill.svg";
import prg6IconGearResearchers from "../assets/program/program6/bi_gear-fill (2).svg";
import prg6IconSpecialists from "../assets/program/program6/streamline-freehand_office-work-wireless.svg";

// Program 7 icons
import prg7IconCommunity from "../assets/program/program7/fluent_people-community-16-filled.svg";
import prg7IconSharing from "../assets/program/program7/icon-park-outline_concept-sharing.svg";
import prg7IconCollab from "../assets/program/program7/Vector (22).svg";
import prg7IconLeadership from "../assets/program/program7/fluent-mdl2_party-leader.svg";
import prg7IconGearStudents from "../assets/program/program7/bi_gear-fill.svg";
import prg7IconGearWorking from "../assets/program/program7/bi_gear-fill (1).svg";
import prg7IconGearIndependent from "../assets/program/program7/bi_gear-fill (2).svg";
import prg7IconGearMentors from "../assets/program/program7/bi_gear-fill (3).svg";

// Program 8 icons
import prg8IconSectors from "../assets/program/program8/fa7-solid_users-gear.svg";
import prg8IconTalent from "../assets/program/program8/Frame 1000010256.svg";
import prg8IconInnovation from "../assets/program/program8/hugeicons_ai-innovation-03.svg";
import prg8IconLeadership from "../assets/program/program8/fluent-mdl2_party-leader.svg";
import prg8IconGearProfessionals from "../assets/program/program8/bi_gear-fill.svg";
import prg8IconGearInstitutions from "../assets/program/program8/bi_gear-fill (1).svg";
import prg8IconGearLeaders from "../assets/program/program8/bi_gear-fill (2).svg";
import prg8IconGovPartners from "../assets/program/program8/Frame 1000010663.png";

// Floating quick contact icons
import floatingIconWhatsapp from "../assets/footer_icone/whatsapp.svg";
import floatingIconEmail from "../assets/footer_icone/gmail.svg";
import floatingIconLinkedin from "../assets/footer_icone/linkin.svg";
import floatingIconPhone from "../assets/footer_icone/phone-icon.png";
import floatingIconMail from "../assets/footer_icone/mail.svg";

// -------------------------------------------------------------
// 4. Partnership (Partnership1.tsx)
// -------------------------------------------------------------
import part1Hero from "../assets/Partnership1/Img1.png";
import part1Benefits from "../assets/Partnership1/Img2.png";
import part1OppOverview from "../assets/Partnership1/Img3.png";
import part1SkillDev from "../assets/Partnership1/Img4.png";
import part1IndustryLearning from "../assets/Partnership1/Img5.png";
import part1AcademiaCollab from "../assets/Partnership1/Img6.png";
import part1Innovation from "../assets/Partnership1/Img8.svg";
import part1CommunityDev from "../assets/Partnership1/Img16.png";
import part1CollabCommunity from "../assets/Partnership1/Img9.png";
import part1CollabWorkforce from "../assets/Partnership1/Img10.png";
import part1CollabSkillDev from "../assets/Partnership1/Img11.png";
import part1CollabEmployability from "../assets/Partnership1/Img12.png";
import part1CollabTechAwareness from "../assets/Partnership1/Img13.png";
import part1CollabWomenInEng from "../assets/Partnership1/Img14.png";
import part1CollabInnovationResearch from "../assets/Partnership1/Img15.png";
import part1ImpactCenter from "../assets/Partnership1/Img16.png";

import part1Icon1 from "../assets/Partnership1/Icon1.svg";
import part1Icon2 from "../assets/Partnership1/Icon2.svg";
import part1Icon3 from "../assets/Partnership1/Icon3.svg";
import part1Icon4 from "../assets/Partnership1/Icon4.svg";
import part1Icon5 from "../assets/Partnership1/Icon5.svg";
import part1Icon6 from "../assets/Partnership1/Icon6.svg";
import part1Icon7 from "../assets/Partnership1/Icon7.svg";
import part1Icon8 from "../assets/Partnership1/Icon8.svg";
import part1Icon9 from "../assets/Partnership1/Icon9.svg";
import part1Icon10 from "../assets/Partnership1/Icon10.svg";
import part1Icon11 from "../assets/Partnership1/Icon11.svg";
import part1Icon12 from "../assets/Partnership1/Icon12.svg";
import part1Icon13 from "../assets/Partnership1/Icon13.svg";
import part1Icon14 from "../assets/Partnership1/Icon14.svg";
import part1Icon15 from "../assets/Partnership1/Icon15.svg";
import part1Icon16 from "../assets/Partnership1/Icon16.svg";
import part1Icon17 from "../assets/Partnership1/Icon17.svg";
import part1Icon18 from "../assets/Partnership1/Icon18.svg";
import part1Icon19 from "../assets/Partnership1/Icon19.svg";
import part1Icon20 from "../assets/Partnership1/Icon20.png";
import part1Icon21 from "../assets/Partnership1/Icon21.svg";

// Combined Extended Maps
export const EMPOWER_IMAGE_MAP = {
  // Main
  empower_main_hero: empowerMainHero,
  empower_card_students: empowerCard1,
  empower_card_graduates: empowerCard2,
  empower_card_professionals: empowerCard3,
  empower_card_institutions: empowerCard4,
  empower_card_independent: empowerCard5,
  empower_card_industries: empowerCard6,
  empower_card_mentors: empowerCard7,
  empower_csr_img1: empowerCsrImg1,
  empower_csr_img2: empowerCsrImg2,
  empower_csr_img3: empowerCsrImg3,
  empower_csr_icon1: empowerCsrIcon1,
  empower_csr_icon2: empowerCsrIcon2,
  empower_csr_icon3: empowerCsrIcon3,
  empower_csr_icon4: empowerCsrIcon4,
  empower_csr_icon5: empowerCsrIcon5,
  empower_csr_icon6: empowerCsrIcon6,
  empower_csr_icon7: empowerCsrIcon7,
  empower_benefit_icon1: empowerBenefitIcon1,
  empower_benefit_icon2: empowerBenefitIcon2,
  empower_benefit_icon3: empowerBenefitIcon3,
  empower_benefit_icon4: empowerBenefitIcon4,
  empower_benefit_icon5: empowerBenefitIcon5,

  // Student Subpage
  empower_student_bg: studentBg,
  empower_student_hero: studentHero,
  empower_student_future_top: studentFutureTop,
  empower_student_future_bottom: studentFutureBottom,
  empower_student_people: studentPeople,
  empower_student_community: studentCommunity,
  empower_student_icon_1: studentIcon1,
  empower_student_icon_2: studentIcon2,
  empower_student_icon_3: studentIcon3,
  empower_student_icon_4: studentIcon4,
  empower_student_icon_5: studentIcon5,
  empower_student_icon_6: studentIcon6,
  empower_student_icon_7: studentIcon7,
  empower_student_icon_8: studentIcon8,
  empower_student_icon_9: studentIcon9,

  // Graduates Subpage
  empower_graduates_bg: gradBg,
  empower_graduates_hero: gradHero,
  empower_graduates_future_top: gradFutureTop,
  empower_graduates_future_bottom: gradFutureBottom,
  empower_graduates_people: gradPeople,
  empower_graduates_community: gradCommunity,
  empower_graduates_icon_1: gradIcon1,
  empower_graduates_icon_2: gradIcon2,
  empower_graduates_icon_3: gradIcon3,
  empower_graduates_icon_4: gradIcon4,
  empower_graduates_icon_5: gradIcon5,
  empower_graduates_icon_6: gradIcon6,
  empower_graduates_icon_7: gradIcon7,
  empower_graduates_icon_8: gradIcon8,
  empower_graduates_icon_9: gradIcon9,

  // Professionals Subpage
  empower_professionals_bg: engBg,
  empower_professionals_hero: engHero,
  empower_professionals_future_top: engFutureTop,
  empower_professionals_future_bottom: engFutureBottom,
  empower_professionals_people: engPeople,
  empower_professionals_community: engCommunity,
  empower_professionals_icon_1: engIcon1,
  empower_professionals_icon_2: engIcon2,
  empower_professionals_icon_3: engIcon3,
  empower_professionals_icon_4: engIcon4,
  empower_professionals_icon_5: engIcon5,
  empower_professionals_icon_6: engIcon6,
  empower_professionals_icon_7: engIcon7,
  empower_professionals_icon_8: engIcon8,
  empower_professionals_icon_9: engIcon9,

  // Independent Subpage
  empower_independent_bg: indBg,
  empower_independent_hero: indHero,
  empower_independent_future_top: indFutureTop,
  empower_independent_future_bottom: indFutureBottom,
  empower_independent_people: indPeople,
  empower_independent_community: indCommunity,
  empower_independent_icon_1: indIcon1,
  empower_independent_icon_2: indIcon2,
  empower_independent_icon_3: indIcon3,
  empower_independent_icon_4: indIcon4,
  empower_independent_icon_5: indIcon5,
  empower_independent_icon_6: indIcon6,
  empower_independent_icon_7: indIcon7,
  empower_independent_icon_8: indIcon8,
  empower_independent_icon_9: indIcon9,

  // Institutions Subpage
  empower_institutions_bg: instBg,
  empower_institutions_hero: instHero,
  empower_institutions_future_top: instFutureTop,
  empower_institutions_future_bottom: instFutureBottom,
  empower_institutions_people: instPeople,
  empower_institutions_community: instCommunity,
  empower_institutions_icon_1: instIcon1,
  empower_institutions_icon_2: instIcon2,
  empower_institutions_icon_3: instIcon3,
  empower_institutions_icon_4: instIcon4,
  empower_institutions_icon_5: instIcon5,
  empower_institutions_icon_6: instIcon6,
  empower_institutions_icon_7: instIcon7,
  empower_institutions_icon_8: instIcon8,
  empower_institutions_icon_9: instIcon9,

  // Employers Subpage
  empower_employers_bg: empBg,
  empower_employers_hero: empHero,
  empower_employers_future_top: empFutureTop,
  empower_employers_future_bottom: empFutureBottom,
  empower_employers_people: empPeople,
  empower_employers_community: empCommunity,
  empower_employers_icon_1: empIcon1,
  empower_employers_icon_2: empIcon2,
  empower_employers_icon_3: empIcon3,
  empower_employers_icon_4: empIcon4,
  empower_employers_icon_5: empIcon5,
  empower_employers_icon_6: empIcon6,
  empower_employers_icon_7: empIcon7,
  empower_employers_icon_8: empIcon8,
  empower_employers_icon_9: empIcon9,

  // Mentors Subpage
  empower_mentors_bg: mentorBg,
  empower_mentors_hero: mentorHero,
  empower_mentors_future_top: mentorFutureTop,
  empower_mentors_future_bottom: mentorFutureBottom,
  empower_mentors_people: mentorPeople,
  empower_mentors_community: mentorCommunity,
  empower_mentors_icon_1: mentorIcon1,
  empower_mentors_icon_2: mentorIcon2,
  empower_mentors_icon_3: mentorIcon3,
  empower_mentors_icon_4: mentorIcon4,
  empower_mentors_icon_5: mentorIcon5,
  empower_mentors_icon_6: mentorIcon6,
  empower_mentors_icon_7: mentorIcon7,
  empower_mentors_icon_8: mentorIcon8,
  empower_mentors_icon_9: mentorIcon9,
  empower_mentors_icon_10: mentorIcon10,
  empower_mentors_icon_11: mentorIcon11,
};

export const PROGRAM_IMAGE_MAP = {
  // Program Subpages Hero Images
  prg_skill_hero: prgSkillHero,
  prg_career_hero: prgCareerHero,
  prg_independent_hero: prgIndHero,
  prg_welfare_hero: prgWelfareHero,
  prg_academia_hero: prgAcademiaHero,
  prg_tech_hero: prgTechHero,
  prg_comm_hero: prgCommHero,
  prg_india_hero: prgIndiaHero,

  // Program Subpages Focus Banners
  prg_skill_focus_banner: prgSkillFocusBanner,
  prg_career_focus_banner: prgCareerFocusBanner,
  prg_independent_focus_banner: prgIndFocusBanner,
  prg_welfare_focus_banner: prgWelfareFocusBanner,
  prg_academia_focus_banner: prgAcademiaFocusBanner,
  prg_tech_focus_banner: prgTechFocusBanner,
  prg_comm_focus_banner: prgCommFocusBanner,
  prg_india_focus_banner: prgIndiaFocusBanner,

  // Program Subpages Who Can Join Photos
  prg_join_photo_skill: prgJoinPhoto1,
  prg_join_photo_career: prgJoinPhoto2,
  prg_join_photo_independent: prgJoinPhoto3,
  prg_join_photo_welfare: prgJoinPhoto4,
  prg_join_photo_academia: prgJoinPhoto5,
  prg_join_photo_tech: prgJoinPhoto6,
  prg_join_photo_comm: prgJoinPhoto7,
  prg_join_photo_india: prgJoinPhoto8,

  // Program Subpages Benefits Photos
  prg_benefits_photo_default: prgBenefitsPhoto1,
  prg_benefits_photo_academia: prgBenefitsPhoto5,
  prg_benefits_photo_tech: prgBenefitsPhoto6,
  prg_benefits_photo_comm: prgBenefitsPhoto7,
  prg_benefits_photo_india: prgBenefitsPhoto8,

  // Program CTA Banner
  prg_cta_engineers_banner: prgCtaBannerEngineers,

  // Common Program Icons
  prg_icon_handshake: prgIconHandshake,
  prg_icon_tech: prgIconTech,
  prg_icon_readiness: prgIconAccountTick,
  prg_icon_eng_baseline: prgIconEng,
  prg_icon_briefcase: prgIconBriefcase,
  prg_icon_search_insights: prgIconSearchInsights,
  prg_icon_factory: prgIconFactory,
  prg_icon_job_search: prgIconJobSearch,
  prg_icon_consulting: prgIconGroup1,
  prg_icon_brain_sparkle: prgIconBrainSparkle,
  prg_icon_iam: prgIconIam,
  prg_icon_id_card: prgIconIdCard,
  prg_icon_community_box: prgIconCommunityBox,

  // Program Subpages Gear Icons
  prg_icon_gear_students: prgIconGearStudents,
  prg_icon_gear_graduates: prgIconGearGraduates,
  prg_icon_gear_jobseekers: prgIconGearJobSeekers,
  prg_icon_gear_earlycareer: prgIconGearEarlyCareer,
  prg_icon_gear_working: prgIconGearWorking,
  prg_icon_gear_freelance: prgIconGearFreelance,
  prg_icon_gear_consultants: prgIconGearConsultants,
  prg_icon_gear_entrepreneurs: prgIconGearEntrepreneurs,
  prg_icon_gear_independent: prgIconGearEntrepreneurs,
  prg_icon_gear_mentors: prgIconGearFreelance,
  prg_icon_gear_professionals: prgIconGearConsultants,
  prg_icon_gear_finalyear: prgIconGearEarlyCareer,

  // Program 5 Specific Icons
  prg5_icon_connect: prg5IconConnect,
  prg5_icon_practical: prg5IconPractical,
  prg5_icon_partnerships: prg5IconPartnerships,
  prg5_icon_graduates: prg5IconGraduates,
  prg5_icon_gear_institutions: prg5IconGearInstitutions,
  prg5_icon_gear_students_faculty: prg5IconGearStudentsFaculty,
  prg5_icon_gear_professionals: prg5IconGearProfessionals,
  prg5_icon_gear_companies: prg5IconGearCompanies,

  // Program 6 Specific Icons
  prg6_icon_innovation: prg6IconInnovation,
  prg6_icon_future_tech: prg6IconFutureTech,
  prg6_icon_adoption: prg6IconAdoption,
  prg6_icon_future_ready: prg6IconFutureReady,
  prg6_icon_gear_working: prg6IconGearWorking,
  prg6_icon_gear_researchers: prg6IconGearResearchers,
  prg6_icon_specialists: prg6IconSpecialists,

  // Program 7 Specific Icons
  prg7_icon_community: prg7IconCommunity,
  prg7_icon_sharing: prg7IconSharing,
  prg7_icon_collab: prg7IconCollab,
  prg7_icon_leadership: prg7IconLeadership,
  prg7_icon_gear_students: prg7IconGearStudents,
  prg7_icon_gear_working: prg7IconGearWorking,
  prg7_icon_gear_independent: prg7IconGearIndependent,
  prg7_icon_gear_mentors: prg7IconGearMentors,

  // Program 8 Specific Icons
  prg8_icon_sectors: prg8IconSectors,
  prg8_icon_talent: prg8IconTalent,
  prg8_icon_innovation: prg8IconInnovation,
  prg8_icon_leadership: prg8IconLeadership,
  prg8_icon_gear_professionals: prg8IconGearProfessionals,
  prg8_icon_gear_institutions: prg8IconGearInstitutions,
  prg8_icon_gear_leaders: prg8IconGearLeaders,
  prg8_icon_gov_partners: prg8IconGovPartners,

  // Floating Quick Contact Icons
  floating_icon_whatsapp: floatingIconWhatsapp,
  floating_icon_email: floatingIconEmail,
  floating_icon_linkedin: floatingIconLinkedin,
  floating_icon_phone: floatingIconPhone,
  floating_icon_mail: floatingIconMail,
};

export const PARTNERSHIP1_IMAGE_MAP = {
  // Main Sections
  part_hero_img: part1Hero,
  part_benefits_img: part1Benefits,
  part_opp_overview_img: part1OppOverview,
  part_skill_dev_img: part1SkillDev,
  part_industry_learning_img: part1IndustryLearning,
  part_academia_collab_img: part1AcademiaCollab,
  part_innovation_img: part1Innovation,
  part_community_dev_img: part1CommunityDev,
  part_impact_center_img: part1ImpactCenter,

  // Areas of Collaboration Images
  part_collab_community: part1CollabCommunity,
  part_collab_workforce: part1CollabWorkforce,
  part_collab_skill_dev: part1CollabSkillDev,
  part_collab_employability: part1CollabEmployability,
  part_collab_tech_awareness: part1CollabTechAwareness,
  part_collab_women_in_eng: part1CollabWomenInEng,
  part_collab_innovation_research: part1CollabInnovationResearch,

  // Why Partner Icons
  part_icon_workforce: part1Icon1,
  part_icon_talent: part1Icon2,
  part_icon_knowledge: part1Icon3,
  part_icon_social_impact: part1Icon4,

  // Opportunity Icons
  part_icon_skill_dev: part1Icon5,
  part_icon_industry_learning: part1Icon6,
  part_icon_academia_collab: part1Icon7,
  part_icon_innovation: part1Icon8,
  part_icon_community_dev: part1Icon9,

  // Impact & Reporting Icons
  part_icon_impact_obj: part1Icon10,
  part_icon_impact_measure: part1Icon11,
  part_icon_impact_resource: part1Icon12,
  part_icon_impact_progress: part1Icon13,
  part_icon_impact_reports: part1Icon14,
  part_icon_impact_governance: part1Icon15,

  // Who Can Partner Icons
  part_icon_partner_industry: part1Icon16,
  part_icon_partner_education: part1Icon17,
  part_icon_partner_csr: part1Icon18,
  part_icon_partner_government: part1Icon19,
  part_icon_partner_professional: part1Icon20,
  part_icon_partner_technology: part1Icon21,
};

export const EXTENDED_IMAGE_OPTIONS = [
  // Empower Main
  { value: "empower_main_hero", label: "Empower — Main Hero Photo" },
  { value: "empower_card_students", label: "Empower Card — Students" },
  { value: "empower_card_graduates", label: "Empower Card — Graduates" },
  { value: "empower_card_professionals", label: "Empower Card — Professionals" },
  { value: "empower_card_institutions", label: "Empower Card — Institutions" },
  { value: "empower_card_independent", label: "Empower Card — Independent" },
  { value: "empower_card_industries", label: "Empower Card — Industries" },
  { value: "empower_card_mentors", label: "Empower Card — Mentors" },
  { value: "empower_csr_img1", label: "Empower CSR — Image 1" },
  { value: "empower_csr_img2", label: "Empower CSR — Image 2" },
  { value: "empower_csr_img3", label: "Empower CSR — Image 3" },

  // Program Subpages
  { value: "prg_skill_hero", label: "Program Sub — Skill Dev Hero" },
  { value: "prg_career_hero", label: "Program Sub — Career Support Hero" },
  { value: "prg_independent_hero", label: "Program Sub — Independent Hero" },
  { value: "prg_welfare_hero", label: "Program Sub — Welfare Hero" },
  { value: "prg_academia_hero", label: "Program Sub — Academia Hero" },
  { value: "prg_tech_hero", label: "Program Sub — Tech Innovation Hero" },
  { value: "prg_comm_hero", label: "Program Sub — Community Dev Hero" },
  { value: "prg_india_hero", label: "Program Sub — India Growth Hero" },
  { value: "prg_cta_engineers_banner", label: "Program Sub — CTA Engineers Banner" },

  // Partnership
  { value: "part_hero_img", label: "Partnership — Hero Photo" },
  { value: "part_benefits_img", label: "Partnership — Benefits Photo" },
  { value: "part_skill_dev_img", label: "Partnership — Skill Development Photo" },
  { value: "part_industry_learning_img", label: "Partnership — Industry Learning Photo" },
  { value: "part_academia_collab_img", label: "Partnership — Academia Collab Photo" },
  { value: "part_innovation_img", label: "Partnership — Innovation Graphic" },
  { value: "part_community_dev_img", label: "Partnership — Community Dev Photo" },
  { value: "part_impact_center_img", label: "Partnership — Impact Center Photo" },
];
